"use strict";

var _ = require('underscore');

/*
 * JavaScript Linkify - v0.3 - 6/27/2009
 * http://benalman.com/projects/javascript-linkify/
 *
 * Copyright (c) 2009 "Cowboy" Ben Alman
 * Dual licensed under the MIT and GPL licenses.
 * http://benalman.com/about/license/
 *
 * Some regexps adapted from http://userscripts.org/scripts/review/7122
 */
var parseLinks = function () {
    var k = "[a-z\\d.-]+://",
        h = "(?:(?:[0-9]|[1-9]\\d|1\\d{2}|2[0-4]\\d|25[0-5])\\.){3}(?:[0-9]|[1-9]\\d|1\\d{2}|2[0-4]\\d|25[0-5])",
        c = "(?:(?:[^\\s!@#$%^&*()_=+[\\]{}\\\\|;:'\",.<>/?]+)\\.)+",
        n = "(?:ac|ad|aero|ae|af|ag|ai|al|am|an|ao|aq|arpa|ar|asia|as|at|au|aw|ax|az|ba|bb|bd|be|bf|bg|bh|biz|bi|bj|bm|bn|bo|br|bs|bt|bv|bw|by|bz|cat|ca|cc|cd|cf|cg|ch|ci|ck|cl|cm|cn|coop|com|co|cr|cu|cv|cx|cy|cz|de|dj|dk|dm|do|dz|ec|edu|ee|eg|er|es|et|eu|fi|fj|fk|fm|fo|fr|ga|gb|gd|ge|gf|gg|gh|gi|gl|gm|gn|gov|gp|gq|gr|gs|gt|gu|gw|gy|hk|hm|hn|hr|ht|hu|id|ie|il|im|info|int|in|io|iq|ir|is|it|je|jm|jobs|jo|jp|ke|kg|kh|ki|km|kn|kp|kr|kw|ky|kz|la|lb|lc|li|lk|lr|ls|lt|lu|lv|ly|ma|mc|md|me|mg|mh|mil|mk|ml|mm|mn|mobi|mo|mp|mq|mr|ms|mt|museum|mu|mv|mw|mx|my|mz|name|na|nc|net|ne|nf|ng|ni|nl|no|np|nr|nu|nz|om|org|pa|pe|pf|pg|ph|pk|pl|pm|pn|pro|pr|ps|pt|pw|py|qa|re|ro|rs|ru|rw|sa|sb|sc|sd|se|sg|sh|si|sj|sk|sl|sm|sn|so|sr|st|su|sv|sy|sz|tc|td|tel|tf|tg|th|tj|tk|tl|tm|tn|to|tp|travel|tr|tt|tv|tw|tz|ua|ug|uk|um|us|uy|uz|va|vc|ve|vg|vi|vn|vu|wf|ws|xn--0zwm56d|xn--11b5bs3a9aj6g|xn--80akhbyknj4f|xn--9t4b11yi5a|xn--deba0ad|xn--g6w251d|xn--hgbk6aj7f53bba|xn--hlcj6aya9esc7a|xn--jxalpdlp|xn--kgbechtv|xn--zckzah|ye|yt|yu|za|zm|zw)",
        f = "(?:" + c + n + "|" + h + ")",
        o = "(?:[;/][^#?<>\\s]*)?",
        e = "(?:\\?[^#<>\\s]*)?(?:#[^<>\\s]*)?",
        d = "\\b" + k + "[^<>\\s]+",
        a = "\\b" + f + o + e + "(?!\\w)",
        m = "mailto:",
        j = "(?:" + m + ")?[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@" + f + e + "(?!\\w)",
        l = new RegExp("(?:" + d + "|" + a + "|" + j + ")", "ig"),
        g = new RegExp("^" + k, "i"),
        b = { "'": "`", ">": "<", ")": "(", "]": "[", "}": "{", "B;": "B+", "b:": "b9" },
        i = { callback: function callback(q, p) {
            return p ? '<a href="' + p + '" title="' + p + '">' + q + "</a>" : q;
        }, punct_regexp: /(?:[!?.,:;'"]|(?:&|&amp;)(?:lt|gt|quot|apos|raquo|laquo|rsaquo|lsaquo);)$/ };return function (u, z) {
        z = z || {};var w,
            v,
            A,
            p,
            x = "",
            t = [],
            s,
            E,
            C,
            y,
            q,
            D,
            B,
            r;for (v in i) {
            if (z[v] === undefined) {
                z[v] = i[v];
            }
        }while (w = l.exec(u)) {
            A = w[0];E = l.lastIndex;C = E - A.length;if (/[\/:]/.test(u.charAt(C - 1))) {
                continue;
            }do {
                y = A;r = A.substr(-1);B = b[r];if (B) {
                    q = A.match(new RegExp("\\" + B + "(?!$)", "g"));D = A.match(new RegExp("\\" + r, "g"));if ((q ? q.length : 0) < (D ? D.length : 0)) {
                        A = A.substr(0, A.length - 1);E--;
                    }
                }if (z.punct_regexp) {
                    A = A.replace(z.punct_regexp, function (F) {
                        E -= F.length;return "";
                    });
                }
            } while (A.length && A !== y);p = A;if (!g.test(p)) {
                p = (p.indexOf("@") !== -1 ? !p.indexOf(m) ? "" : m : !p.indexOf("irc.") ? "irc://" : !p.indexOf("ftp.") ? "ftp://" : "http://") + p;
            }if (s != C) {
                t.push([u.slice(s, C)]);s = E;
            }t.push([A, p]);
        }t.push([u.substr(s)]);for (v = 0; v < t.length; v++) {
            x += z.callback.apply(window, t[v]);
        }return x || u;
    };
}();

module.exports = {
    toHTML: function toHTML(msg, team) {
        var html = this.escapeHTML(msg);
        return this.linkify(html);
    },
    linkify: function linkify(text) {
        return parseLinks(text, {
            callback: function callback(text, href) {
                return href ? '<a href="' + href + '" target="_blank">' + text + '</a>' : text;
            }
        });
    },
    collectLinks: function collectLinks(text) {
        var links = [];
        parseLinks(text, {
            callback: function callback(text, href) {
                if (!href) return;
                links.push(href);
            }
        });
        return links;
    },
    escapeHTML: function escapeHTML(s) {
        var re = /[&\"'<>]/g,
            // "
        map = { "&": "&amp;", "\"": "&quot;", "'": "&apos;", "<": "&lt;", ">": "&gt;" };
        return s.replace(re, function (c) {
            return map[c];
        });
    }
};


//////////////////
// WEBPACK FOOTER
// ./helpers/htmlify.js
// module id = 790
// module chunks = 2